import React, { FunctionComponent, Fragment } from 'react';
import { Paragraph, Password, Text } from '@mlc/web-ui-toolkit';
import * as Styled from './styled';
import AccountTestIds from '../Account/Account.elements';

type Props = {
	inputHandler: (password: string, isPasswordValid: boolean) => void;
	isCriteriaMet: boolean;
	isInvalid: boolean;
	mode: string;
};

const PasswordForm: FunctionComponent<Props> = ({
	mode,
	inputHandler,
	isCriteriaMet,
	isInvalid,
}) => {
	return (
		<Fragment>
			<div>
				<Paragraph paddingBottom={6} aria-hidden={true}>
					Register a password to use with the financial planning software you
					use to connect with Client Data Exchange:
				</Paragraph>
				<Styled.FieldWrapper
					label={<Text fontWeight="semibold">Type your password</Text>}
					error={
						isCriteriaMet ? (
							'Password required'
						) : (
							<span aria-labelledby={'invalidPassword'}>
								{"Password doesn't meet requirements"}
							</span>
						)
					}
					isInvalid={isInvalid}
				>
					<Password
						mode={mode}
						data-id={AccountTestIds.passwordField}
						name="Password"
						label="Password"
						onChange={(event: any, isPasswordValid: boolean) => {
							inputHandler(event.target.value, isPasswordValid);
						}}
						data-analytics-capture-value={false}
						autoComplete="new-password"
					/>
				</Styled.FieldWrapper>
				<span className="sr-only" id="invalidPassword">
					Please match the requested format. Your password should include at
					least 8 characters, at least one lowercase letter, an uppercase
					letter, a number and a special character. An example of a special
					character is @, # and %.
				</span>
			</div>
		</Fragment>
	);
};

export default PasswordForm;
